module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/12x12-9c74a2ebb561b2c0cf9fbb9a786ec120.svg";